import { NextPage } from 'next';
import React, { useMemo } from 'react';

import MainLayout from '@app/components/MainLayout';
import { usePairDetails } from '@app/hooks/pair/usePairDetails';
import { APP_NAME } from '@app/constants/common';
import { WithdrawLiquidity } from '@app/components/WithdrawLiquidity';
import { useWithdrawLiquidityAvailability } from '@app/hooks/liquidity/useWithdrawLiquidityAvailability';
import { useRouter } from 'next/router';
import { Center, Flex, Spinner } from '@chakra-ui/react';

export const RemoveLiquidityPage: NextPage = () => {
  const { query } = useRouter();
  const { pairId } = query;

  const { balance, getWithdrawBalance, loading } =
    useWithdrawLiquidityAvailability(pairId as string);

  const { data: pair, isLoading: isLoadingPair } = usePairDetails({
    id: (pairId as string)?.toLowerCase()
  });

  const isLoading = loading || isLoadingPair;

  const initialData = useMemo(() => {
    if (!pair) {
      return null;
    }

    return pair ? { pair } : null;
  }, [pair]);

  return (
    <MainLayout metadata={{ title: `Remove Liquidity | ${APP_NAME}` }}>
      {isLoading && (
        <Flex
          w="100%"
          h="100%"
          minHeight="calc(100dvh - 200px)"
          justifyContent="center"
        >
          <Center>
            <Spinner color="green.1" width={8} height={8} />
          </Center>
        </Flex>
      )}
      {initialData && balance && !isLoading ? (
        <WithdrawLiquidity
          pair={initialData?.pair}
          balance={balance}
          getWithdrawBalance={getWithdrawBalance}
        />
      ) : null}
    </MainLayout>
  );
};

export default RemoveLiquidityPage;
